import React from 'react'
import ChipInput from 'material-ui-chip-input'
import { useAddPartExclusion, useRemovePartExclusion } from '../../../hooks/queries/exclusions'
import { Typography } from '@material-ui/core'

export default function ExcludePartsChips({ dataArray, refetchData }) {
  const { mutateAsync: addPartAPI } = useAddPartExclusion()
  const { mutateAsync: removePartAPI } = useRemovePartExclusion()

  const handleAddChip = async (chips) => {
    const excludeAPIInput = chips.split(' ').map((chip) => ({
      partNumber: chip,
      excludeOnlyChildren: false,
    }))

    await addPartAPI({ partNumbers: excludeAPIInput })
    refetchData()
  }

  const handleDeleteChip = async (chip) => {
    await removePartAPI({ partNumbers: [chip] })
    refetchData()
  }

  return (
    <>
      <Typography className='exclusion-title'>Parts To exclude from CTB</Typography>
      <ChipInput
        dataSource={['something', 'somethingelse']}
        placeholder={'Paste a List of part numbers or type one to exclude'}
        alwaysShowPlaceholder
        fullWidthInput
        variant={'outlined'}
        value={dataArray}
        onAdd={(chip) => handleAddChip(chip)}
        onDelete={(chip, index) => handleDeleteChip(chip, index)}
      />
    </>
  )
}
